import React from "react";
import styled from "styled-components";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";

const Background = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: #ffffffb7;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const LoadingText = styled.div`
  font: 1rem "Noto Sans KR";
  text-align: center;
`;

const Loading = () => {
  return (
    <Background>
      <CircularProgress
        size={50}
        sx={{
          color: green[500],
          position: "absolute",
          marginTop: "-100px",
        }}
      />
      <LoadingText>잠시만 기다려 주세요.</LoadingText>
    </Background>
  );
};

export default Loading;
